export const pushToDataLayer = (event: string, data?: any) => {
  if (typeof window !== "undefined") {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event,
      ...data,
    });
  }
};

export const trackBookingSuccess = (data?: any) => {
  pushToDataLayer("gh_booking_success", data);
};

export const trackFormStart = (formName: string) => {
  pushToDataLayer("gh_form_start", { form_name: formName });
};

export const trackCheckAvailability = (data?: any) => {
  pushToDataLayer("gh_check_availability", data);
};

export const trackContactSubmit = (data?: any) => {
  pushToDataLayer("gh_contact_submit", data);
};

export const trackCommunicationClick = (type: "whatsapp" | "phone" | "email", value: string) => {
  pushToDataLayer("gh_click_communication", {
    communication_type: type,
    communication_value: value,
  });
};
